import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../types"
import { ExistingPlanOptions } from "../../../../types"

export const confirmOverrideTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    existingPlanOptionsModal: true,
    existingPlanOption: ExistingPlanOptions.NO_OVERRIDE
  }),
  exit: assign<Context>({
    existingPlanOptionsModal: false,
    overrideSchoolsCount: 0,
    overrideTeachersCount: 0,
    overrideClassesCount: 0
  }),
  on: {
    "no_override.update": {
      actions: assign<Context>({
        existingPlanOption: ExistingPlanOptions.NO_OVERRIDE
      })
    },
    "override.update": {
      actions: assign<Context>({
        existingPlanOption: ExistingPlanOptions.OVERRIDE
      })
    },
    SAVE: {
      // call API and pass it the option selected
      target: "#StudyPlan.save_study_plan_transition"
    },
    CANCEL: [
      {
        target: "edit_plan",
        cond: ctx => ctx.previousParentState === "edit_plan",
        actions: assign<Context>({
          existingPlanOption: null
        })
      },
      {
        target: "review_plan",
        cond: ctx => ctx.previousParentState === "review_plan",
        actions: assign<Context>({
          existingPlanOption: null
        })
      }
    ]
  }
}
